import React from "react";

import { RichTextSectionBlock as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";

const components = {
    rich_text_stream: RichTextStreamBlock,
    spacer: SpacerBlock,
};

export const RichTextSectionBlock = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField components={components} value={value.items} />
        </Themed>
    );
};
